import { Injectable } from '@angular/core';

/**
 * Controls the Brevo Conversations chat widget. The widget is intentionally limited to the
 * public lead-gen pages (login + onboarding) so it does not overlap UI in the authenticated
 * app. The script is injected lazily on first `show()` and then toggled via Brevo's `show`/
 * `hide` commands on subsequent route changes.
 */
@Injectable({ providedIn: 'root' })
export class BrevoChatService {
    private readonly widgetId = '66a5c16bbb59664cd80865e0';
    private injected = false;

    private get api(): any {
        return (window as any).BrevoConversations;
    }

    // Injects the Brevo script once. The command-queue stub is defined synchronously so any
    // show/hide calls made before the script finishes loading are queued and applied later.
    private ensureInjected(): void {
        if (this.injected) {
            return;
        }
        this.injected = true;

        const w = window as any;
        const d = document;
        const c = 'BrevoConversations';
        w.BrevoConversationsID = this.widgetId;
        w[c] =
            w[c] ||
            function () {
                // eslint-disable-next-line prefer-rest-params
                (w[c].q = w[c].q || []).push(arguments);
            };

        const s = d.createElement('script');
        s.async = true;
        s.src = 'https://conversations-widget.brevo.com/brevo-conversations.js';
        if (d.head) {
            d.head.appendChild(s);
        }
    }

    show(): void {
        this.ensureInjected();
        try {
            if (typeof this.api === 'function') {
                this.api('show');
            }
        } catch {
            // Non-critical: chat widget must never break navigation.
        }
    }

    hide(): void {
        // Only meaningful once the script/queue exists; if it was never loaded there is
        // nothing to hide.
        try {
            if (typeof this.api === 'function') {
                this.api('hide');
            }
        } catch {
            // Non-critical.
        }
    }
}
